import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

function DemoBanner() {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-black text-center py-2 px-4 text-sm font-bold tracking-wide" data-testid="demo-banner">
      DEMO WEBSITE — This site is for demonstration purposes only. Contact information is not active.
    </div>
  );
}

export default function Layout() {
  return (
    <div className="min-h-screen bg-casino-black noise-overlay flex flex-col">
      <DemoBanner />
      <div className="pt-8">
        <Navbar />
        <main className="flex-1 relative z-10">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
